import { fromHex } from "viem";

export const getDidName = (did: string) => {
  if (
    did ===
      "0x0000000000000000000000000000000000000000000000000000000000000000" ||
    !did
  ) {
    return "";
  }
  return fromHex(did as `0x${string}`, "string");
};
